import api from './api';

export const variablesService = {
  getVariables: async () => {
    const response = await api.get('/api/variables');
    return response.data;
  },

  createVariable: async (variable) => {
    const response = await api.post('/api/variables', variable);
    return response.data;
  },

  updateFavourite: async (id, favourite) => {
    const response = await api.patch(`/api/variables/${id}/favourite`, { favourite });
    return response.data;
  },

  deleteVariable: async (id) => {
    const response = await api.delete(`/api/variables/${id}`);
    return response.data;
  },
};
